var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ChevronUpThinIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 55,
    glyphHeight: 40,
    glyphOffsetX: -2
  }), React.createElement("path", {
    d: "M59.5032 30.066L56.4021 33.1492L29.7808 6.28382L3.11044 33.1005L0.0149119 30.0117L29.7865 0.0417312L59.5032 30.066Z"
  }));
};
export var ChevronUpThinIconGlyph = function (props) {
  return React.createElement(ChevronUpThinIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};